import api from "../index";
import store from '@/store';
import {
	IAuthLogin,
	IFirebaseToken,
	IPreAuthLogin,
	IPreAuthResponseData
} from "./interface";
import { authEntity } from "@/models/modules/auth/entity";
import auth from "@/models/modules/auth";
import { isSuccessResponseStatusCode } from "../handler";
import { AUTH_MODULE_NAME } from "@/store/modules/auth";
import FraudHandler from "@/modules/security/fraud-handler";

const setResetNotificationTrack = (_value: boolean) =>
	store.commit(`${AUTH_MODULE_NAME}/setResetNotificationTrack`, _value);

export const $preAuth = (v: IPreAuthLogin): Promise<IPreAuthResponseData> => api
	.post("auth/pre-login", v, {
		handler: { dontAuth: true, showModalOnError: false }
	});

export const $auth = (v: IAuthLogin): Promise<boolean> => api
	.post("auth/login", v, {
		handler: { dontAuth: true, showModalOnError: false }
	})
	.then(r => {
		auth.signIn(r);

		return authEntity.isAuth;
	});

export const $logoutRequest = (): Promise<boolean> => api
	.post("auth/logout", undefined, {
		handler: {
			ignoreErrorHandler: true,
			returnData: false,
			skipSessionExpired: true
		}
	})
	.then(response => isSuccessResponseStatusCode(response?.status));

export const $logout = async (): Promise<any> => $logoutRequest()
	.then(() => {
		setResetNotificationTrack(true);
		FraudHandler.onLogout();
		auth.signOutAndRedirectToAuth();
	});

export const $refreshToken = (): Promise<boolean> => api
	.post("auth/refresh-token",
		{
			accessToken: authEntity.accessToken,
			refreshToken: authEntity.refreshToken
		},
		{ handler: { dontAuth: true }
	})
	.then(r => {
		auth.signIn(r);

		return authEntity.isAuth;
	});

export const $setFcmToken = (token: string): Promise<IFirebaseToken> => api
	.put("customer/firebase-token", { token });